import { render, staticRenderFns, recyclableRender, components } from "./webview.vue?vue&type=template&id=baadaa0c&"
var renderjs
import script from "./webview.vue?vue&type=script&lang=js&"
export * from "./webview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/webview/webview.vue"
export default component.exports